
// eslint-disable-next-line max-len
const emojiRegex = new RegExp('\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]')

const isEmoji = (emoji) => 
emojiRegex.test(emoji)

export default isEmoji